import { render, staticRenderFns } from "./sidebar_editable_item.vue?vue&type=template&id=1753bdbe"
import script from "./sidebar_editable_item.vue?vue&type=script&lang=js"
export * from "./sidebar_editable_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports